import { render, staticRenderFns } from "./add-bateria-virtual.vue?vue&type=template&id=f73ee9da&"
import script from "./add-bateria-virtual.vue?vue&type=script&lang=js&"
export * from "./add-bateria-virtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports